<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<style src="./App.css" />